import { render, staticRenderFns } from "./FBSSettings.vue?vue&type=template&id=741382bc"
import script from "./FBSSettings.vue?vue&type=script&lang=js"
export * from "./FBSSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports